import React from 'react'
import { useSelector } from 'react-redux'
import { selectCmsDescription } from '../../store/seo/seo.selectors'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import TextCssShortener from '../genericComponents/TextCssShortener'
import { withFrenchLanguage } from '../i18n/i18nSite'
import HTMLTextFromMarkdown from '../ui/HTMLTextFromMarkdown'
import s from './CityDescription.less'

const CityDescription = () => {
  const cmsDescription = useSelector(selectCmsDescription)

  if (!cmsDescription) return <></>

  return (
    <TextCssShortener className={s.description}>
      <HTMLTextFromMarkdown htmlText={cmsDescription} />
    </TextCssShortener>
  )
}

export default withEmptyFallbackErrorBoundary(withFrenchLanguage(CityDescription))
